(function () {
  'use strict';

  angular.module("lif.filters").filter("unsafe", unsafeHtmlFilter).filter('htmlToPlainText', function () {
    return function (text) {
      return angular.element(text).text();
    };
  });
  unsafeHtmlFilter.$inject = ['$sce'];

  function unsafeHtmlFilter($sce) {
    return $sce.trustAsHtml;
  }

  ;
})();